export default __webpack_public_path__ + "static/media/credit-card.8e69996a.svg";